import { render } from "./FormularioFacturacion.vue?vue&type=template&id=58446e3a&scoped=true"
import script from "./FormularioFacturacion.vue?vue&type=script&lang=js"
export * from "./FormularioFacturacion.vue?vue&type=script&lang=js"

import "./FormularioFacturacion.vue?vue&type=style&index=0&id=58446e3a&scoped=true&lang=css"

import exportComponent from "D:\\GIT\\Interfaz_Colecturia\\colecturia\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58446e3a"]])

export default __exports__